// ==================== PANDADOC STATUS & REFERENCES ====================

export enum PandaDocStatus {
  DRAFT = "document.draft",
  SENT = "document.sent",
  COMPLETED = "document.completed",
  UPLOADED = "document.uploaded",
  ERROR = "document.error",
  VIEWED = "document.viewed",
  WAITING_APPROVAL = "document.waiting_approval",
  APPROVED = "document.approved",
  REJECTED = "document.rejected",
  WAITING_PAY = "document.waiting_pay",
  PAID = "document.paid",
  VOIDED = "document.voided",
  DECLINED = "document.declined",
  EXTERNAL_REVIEW = "document.external_review",
}

export interface PandaDocReference {
  document_id: string;
  document_name: string;
  status: PandaDocStatus;
}

// ==================== PANDADOC REQUESTS ====================

export interface PandaDocRecipient {
  email?: string;
}

export interface SendEligibilitySignatureRequest {
  recipient: PandaDocRecipient;
  additional_recipients: PandaDocRecipient[];
  reply_to: PandaDocRecipient;
  message: string;
}

// ==================== PARTNER PANDADOC CONFIGURATION ====================

/**
 * Defines how documents are isolated per partner
 */
export enum PandaDocIsolationMode {
  /** Documents are isolated to partner-specific folders */
  FOLDER = "folder",
  /** Documents are isolated to partner-specific workspaces */
  WORKSPACE = "workspace",
}

/**
 * Partner-specific PandaDoc configuration
 * Fetched from GET /partners/{id}/configuration/pandadoc
 */
export interface PandaDocConfig {
  isolation_mode?: PandaDocIsolationMode;
  /** @deprecated Use template_folder_uuid and document_folder_uuid */
  folder_uuid?: string;
  /** Folder containing partner's PandaDoc templates */
  template_folder_uuid?: string;
  /** Folder where signed documents are stored */
  document_folder_uuid?: string;
  /** Workspace ID for workspace-level isolation */
  workspace_id?: string;
  /** Environment variable name for partner-specific PandaDoc API key */
  credential_ref?: string;
  /** Environment variable name for partner-specific webhook secret */
  webhook_secret_ref?: string;
}

/**
 * Template available in partner's PandaDoc folder
 * Returned from GET /partners/{id}/pandadoc/templates
 */
export interface PandaDocTemplate {
  id: string;
  name: string;
  date_created?: string;
  date_modified?: string;
}

/**
 * Folder in PandaDoc
 * Returned from GET /partners/{id}/pandadoc/folders/templates or /documents
 */
export interface PandaDocFolder {
  id: string;
  name: string;
  has_folders: boolean;
  has_items: boolean;
}
